import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import {
  FirewallAdvancedRule,
  FirewallAdvancedRuleCustomProtocolType,
  FirewallAdvancedRuleFormValue,
  FirewallAdvancedRulePermissionType,
  FirewallAdvancedRuleProtocolType,
  FirewallAdvancedRuleSettingsDirection,
} from '@nirvana/shared/dtos/types/policies/common';
import { getConvertedProtocolTypeForFrontend } from '../../../../utils/uiSettings/firewall/firewall.values';
import { SetFiltersRequest } from '../../../../../../../grid/types/common';
import { convertRegexFilterToStartsWithFilter } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';
import {
  FirewallAdvancedNetworkFrontend,
  FirewallAdvancedRuleProtocolTypeForFrontend,
} from '../../../../utils/uiSettings/firewall/firewall.types';

export interface FirewallAdvancedRuleFormValueWithAdditionalFrontendFields extends FirewallAdvancedRuleFormValue {
  name: string;
  status: number;
  network: FirewallAdvancedNetworkFrontend[];
  protocol: FirewallAdvancedRuleCustomProtocolType | FirewallAdvancedRuleProtocolTypeForFrontend;
  setPermission: FirewallAdvancedRulePermissionType;
  localIp: string;
  localPort: string;
  remoteIp: string;
  remotePort: string;
  direction: FirewallAdvancedRuleSettingsDirection;
  mac: string;
}

export class GzFirewallAdvancedRulesGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  FirewallAdvancedRule
> {
  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.NAME);
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.LOCAL_IP);
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.LOCAL_PORT);
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.REMOTE_IP);
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.REMOTE_PORT);
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.MAC);
    return;
  }

  protected getItemsWithAdditionalFrontendFields(items: FirewallAdvancedRuleFormValue[]): any[] {
    return items.map(item => this.getConvertedItemToFrontend(item));
  }

  private getConvertedItemToFrontend(
    item: FirewallAdvancedRuleFormValue
  ): FirewallAdvancedRuleFormValueWithAdditionalFrontendFields {
    const network: FirewallAdvancedNetworkFrontend[] = [];
    if (item.permission.home) {
      network.push(FirewallAdvancedNetworkFrontend.HOME);
    }
    if (item.permission.public) {
      network.push(FirewallAdvancedNetworkFrontend.PUBLIC);
    }

    return {
      ...item,
      name: item.details.name,
      status: item.enabled ? 1 : 0,
      network: network,
      protocol:
        item.settings.protocol === FirewallAdvancedRuleProtocolType.CUSTOM
          ? item.settings.customProtocol
          : getConvertedProtocolTypeForFrontend(item.settings.protocol),
      setPermission: item.permission.setPermission,
      localIp: item.settings.localAddress.ipMask ?? '',
      localPort: item.settings.localAddress.portRange,
      remoteIp: item.settings.remoteAddress.ipMask ?? '',
      remotePort: item.settings.remoteAddress.portRange,
      direction: item.settings.direction,
      mac: item.settings.directlyConnected.remoteMac ?? '',
    };
  }
}
